import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { connect } from 'react-redux';
import forEach from 'lodash/forEach';
import ButtonWithIcon from 'chameleon/ui-stack/ui/buttons/button-with-icon';
import { actions } from 'chameleon/ui-stack/ui/units/subunits-list';
import { isCollapsedSubunit } from 'chameleon/ui-stack/ui/units/utils';

const CONSTANTS = {
  EXPAND: 'Expand all',
  COLLAPSE: 'Collapse all',
};

const ExpandButton = (props) => {
  const {
    className,
    visitedSubunits,
    setAllVisitedSubunits,
    subunits,
    subjectId,
    unitNumber,
    userData,
  } = props;
  const {
    me: { initId: userId },
  } = userData;
  const [subunitsObject, setSubunitsObject] = useState({});
  const [isExpanded, setIsExpanded] = useState(false);

  useEffect(() => {
    if (subunits) {
      const collapsedSubunitFound = isCollapsedSubunit({
        subjectId,
        userId,
        unitNumber,
        subunits,
        visitedSubunits,
      });

      setIsExpanded(!collapsedSubunitFound);
    }
  }, [visitedSubunits, subunits]);

  const onClick = () => {
    const newIsExpanded = !isExpanded;
    setIsExpanded(!isExpanded);

    const _visitedSubunits = {};
    forEach(subunitsObject, (value, key) => {
      _visitedSubunits[key] = newIsExpanded;
    });

    setAllVisitedSubunits({
      subjectId,
      userId,
      unitNumber,
      visitedSubunits: _visitedSubunits,
    });
  };

  useEffect(() => {
    let _subunitsObject = {};
    (subunits || []).forEach(({ number, subunitId, resources }) => {
      if ((number || subunitId) && resources.length > 0) {
        _subunitsObject[number || subunitId] = false;
      }
    });

    setSubunitsObject(_subunitsObject);
  }, [subunits]);

  const label = CONSTANTS[isExpanded ? 'COLLAPSE' : 'EXPAND'];
  return (
    <ButtonWithIcon
      isSecondary
      onClick={onClick}
      icon="sort_default"
      className={cn(className)}
      iconAccessibility={{ ariaHidden: true }}
      labelProps={{ 'aria-live': 'polite' }}
    >
      {label}
    </ButtonWithIcon>
  );
};

ExpandButton.propTypes = {
  className: PropTypes.string,
  unitNumber: PropTypes.string,
  visitedSubunits: PropTypes.object,
  subunits: PropTypes.array.isRequired,
};

ExpandButton.defaultProps = {
  className: '',
  unitNumber: '',
  visitedSubunits: {},
};

const mapStateToProps = ({ visitedSubunits, userData }) => ({
  visitedSubunits,
  userData,
});
export default connect(mapStateToProps, {
  setAllVisitedSubunits: actions.setAllVisitedSubunitsAction,
})(ExpandButton);
